import { render, staticRenderFns } from "./LojaPerfeitaListSkeleton.vue?vue&type=template&id=1ca7e309&"
import script from "./LojaPerfeitaListSkeleton.vue?vue&type=script&lang=js&"
export * from "./LojaPerfeitaListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports